import type { ModalConfig } from "./types";

export const companyModalsModalUrlConfig = {
  // Company Modals
  "companies-detail": {
    modalId: "companies-detail",
    entityName: "companies",
    singularParam: "companyId",
    pluralParam: "companiesId",
    displayName: "Company",
  },
  "create-companies": {
    modalId: "create-companies",
    entityName: "companies",
    singularParam: "companyId",
    pluralParam: "companiesId",
    displayName: "Company",
  },
  "edit-companies": {
    modalId: "edit-companies",
    entityName: "companies",
    singularParam: "companyId",
    pluralParam: "companiesId",
    displayName: "Company",
  },
  // History & Audit is a PLACE (MODAL_BROWSER_HISTORY) — see the twin entry in
  // contact-modals.ts for why registration here is load-bearing.
  "companies-audit-history": {
    modalId: "companies-audit-history",
    entityName: "companies",
    singularParam: "companyId",
    pluralParam: "companiesId",
    displayName: "Company",
  },
} as const satisfies Record<string, ModalConfig>;
